export class URNUtil {

  public static createNutrientUrn(activityCode: string, nutrientCode: string): string {
    return 'urn:neovia:' + activityCode + ':nutrient:' + nutrientCode;
  }
}
